/* eslint-disable no-use-before-define */
import Component from '@bythepixel/component-loader';

const formSuccessClass = 'form--success';
const modalSuccessClass = 'modal--success';

export default class Form extends Component {
  static selector = '[data-comp-form]';

  constructor(...args) {
    super(...args);

    this.initForm();

    this.endpoint = this.$container.dataset.endpoint || '/api/email/contact-request/';
    this.isTailgatingForm = this.$container.dataset.compForm === 'tailgating';

    this.allMessageContainers = this.$container.querySelectorAll(
      '[data-comp-form-message]',
    );
    this.formMessageContainer = this.$container.querySelector(
      '[data-comp-form-message="form"]',
    );

    this.successMessageContainer = this.$container.querySelector(
      '[data-comp-success-message]',
    );

    // Keeps track of the initial button text
    // Button text is updated throughout the form submission process
    const button = this.$container.querySelector('button[type="submit"]');
    this.buttonTextEl = button.querySelector('.btn__text');
    this.initialButtonText = this.buttonTextEl.innerText;

    // Gets the modal containing the form
    this.modalId = `${this.$container.dataset.compForm}-modal`;
    this.modal = document.getElementById(this.modalId);
  }

  changeButtonText(text) {
    this.buttonTextEl.innerText = text;
  }

  clearFieldMessages() {
    this.allMessageContainers.forEach((el) => {
      while (el.firstChild) el.removeChild(el.firstChild);
    });
  }

  disableForm() {
    this.$container.querySelector('button[type="submit"]').disabled = true;
  }

  enableForm() {
    this.$container.querySelector('button[type="submit"]').disabled = false;
  }

  eventsForm() {
    this.$container.addEventListener('submit', (e) => {
      e.preventDefault();
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(window.Transwest.recaptchaSiteKey, {
            action: 'submit',
          })
          .then((token) => {
            this.submitForm(e, token);
          });
      });
    });
  }

  handleFieldErrors(formErrors) {
    Object.keys(formErrors).forEach((fieldName) => {
      formErrors[fieldName].forEach((err) => {
        renderMessage(
          this.$container.querySelector(
            `[data-comp-form-message="${fieldName}"]`,
          ),
          err,
          'error',
        );
      });
    });
  }

  handleSuccessfulTailgateSubmission() {
    const { parentElement } = this.$container;
    const postSubmitContent = parentElement.querySelector(
      '[data-post-submit-content]',
    );
    parentElement.dataset.success = 'true';
    postSubmitContent.ariaHidden = false;
    this.$container.setAttribute('disabled', true);
  }

  async handleServerResponse(resp) {
    const data = await resp.json();
    this.clearFieldMessages();

    if (resp.status === 200 && this.isTailgatingForm) {
      this.handleSuccessfulTailgateSubmission();

      return data;
    }

    if (resp.status === 200) {
      this.showServerSuccessMsg(data);
    } else if (resp.status === 422 || resp.status === 400) {
      this.showServerValidationMsg(data);
    } else {
      this.showServerErrorMsg(data);
    }
    return data;
  }

  handleValidationErrors(resp) {
    if (resp.errors) {
      this.handleFieldErrors(resp.errors);
    }
  }

  initForm() {
    this.eventsForm();
  }

  resetButtonText() {
    this.changeButtonText(this.initialButtonText);
  }

  resetForm() {
    this.clearFieldMessages();
    this.enableForm();
  }

  showServerErrorMsg() {
    renderMessage(
      this.formMessageContainer,
      '<strong>Error!</strong> Something went wrong. Please try again later while we check this out.',
      'error',
    );
  }

  showServerSuccessMsg(data) {
    if (this.successMessageContainer) {
      const text = getMessageHTML(data.message, 'success');
      this.successMessageContainer.innerHTML = text;
    }

    if (this.modal) {
      this.modal.classList.add(modalSuccessClass);
    }

    this.$container.classList.add(formSuccessClass);
  }

  showServerValidationMsg(resp) {
    renderMessage(this.formMessageContainer, resp.message, 'error');
  }

  showServerPendingMsg() {
    this.changeButtonText('Sending...');
  }

  async submitForm(e, token) {
    this.clearFieldMessages();
    this.disableForm();

    const formData = new FormData(e.target);
    formData.append('token', token);

    this.showServerPendingMsg();
    const resp = await fetch(this.endpoint, {
      method: 'post',
      body: formData,
    });

    const data = await this.handleServerResponse(await resp);

    this.enableForm();
    this.resetButtonText();
    this.handleValidationErrors(data);
  }
}

function getMessageHTML(message, level = 'notice') {
  return `<p class="tw-message tw-message--${level}">${message}</p>`;
}

function renderMessage(container, err, level) {
  container.insertAdjacentHTML('beforeend', getMessageHTML(err, level));
}
